import { styled, TextField } from "@mui/material";
// import React from "react";

const InputField = styled(TextField)({
  "&": {
    width: "100%",
  },

  // label on focus
  "& label.Mui-focused": {
    color: "#8f92a1cc",
    fontWeight: 700,
    fontSize: "14px",
  },

  // Underline before focus on InputField //
  "& .MuiInput-underline::before": {
    borderBottom: "1px solid rgba(143, 146, 161, 0.2)",
  },

  //  Underlone after focus //
  "& .MuiInput-underline::after": {
    borderBottom: "1px solid rgba(143, 146, 161, 0.2)",
    transition: "none",
  },

  // asterisk style in label //
  "& .MuiInputLabel-asterisk": {
    color: "red",
  },

  // Input Text Styles //
  "& .MuiInputBase-input": {
    color: "#171717",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: 24,
  },
  // "& .MuiInputBase-input::placeholder": {
  //   color: "red !important",
  // },

  // placeholder label shown inside Field //
  "& .MuiInputLabel-root": {
    fontWeight: 500,
    color: "#8f92a1cc",
    fontSize: "14px",
  },

  // hover on color on Bottom //
  "&& .MuiInput-underline:hover:before": {
    borderBottom: "1px solid rgba(143, 146, 161, 0.2)",
  },
  // "& .MuiInputLabel-root::after": {
  //   color: "#8F92A1",
  // },
});

export default InputField;
